module.exports = __webpack_public_path__ + "img/head_0dbee.png";